import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const KtmbCalendar = ({
  calendarDate,
  getDaysInMonth,
  formatCalendarDate,
  isToday,
  isSelected,
  isPastDate,
  onDateSelect,
  onClose,
  onPrevMonth,
  onNextMonth
}) => {
  const days = getDaysInMonth(calendarDate);

  return (
    <div className="ktmb-calendar-overlay">
      <div className="ktmb-calendar-modal">
        <div className="ktmb-calendar-header">
          <button className="ktmb-calendar-close" onClick={onClose}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </button>
          <h2 className="ktmb-calendar-title">Select Date</h2>
        </div>
        <div className="ktmb-calendar-nav">
          <button className="ktmb-calendar-nav-btn" onClick={onPrevMonth}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          <div className="ktmb-calendar-month">{formatCalendarDate(calendarDate)}</div>
          <button className="ktmb-calendar-nav-btn" onClick={onNextMonth}>
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
        <div className="ktmb-calendar-grid">
          <div className="ktmb-calendar-weekdays">
            {weekDays.map(day => (
              <div key={day} className="ktmb-calendar-weekday">{day}</div>
            ))}
          </div>
          <div className="ktmb-calendar-days">
            {days.map((day, index) => (
              <div key={index} className="ktmb-calendar-day-container">
                {day ? (
                  <button
                    className={`ktmb-calendar-day ${
                      isToday(day) ? 'today' : ''
                    } ${
                      isSelected(day) ? 'selected' : ''
                    } ${
                      isPastDate(day) ? 'past' : ''
                    }`}
                    onClick={() => !isPastDate(day) && onDateSelect(day)}
                    disabled={isPastDate(day)}
                  >
                    {day.getDate()}
                  </button>
                ) : (
                  <div className="ktmb-calendar-day empty"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default KtmbCalendar; 